/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponsePagedResultConversationItemList } from '../../models/api-response-paged-result-conversation-item-list';
import { PagedRequestAnalyticsRequest } from '../../models/paged-request-analytics-request';

export interface GetWaitingAgent$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
      body: PagedRequestAnalyticsRequest
}

export function getWaitingAgent(http: HttpClient, rootUrl: string, params: GetWaitingAgent$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponsePagedResultConversationItemList>> {
  const rb = new RequestBuilder(rootUrl, getWaitingAgent.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponsePagedResultConversationItemList>;
    })
  );
}

getWaitingAgent.PATH = '/v1/api/ui/reporting/waiting-agent';
